var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { slot: "pageContent" }, slot: "pageContent" },
    [
      _vm.displayWeb
        ? _c("web-service-credential-form", {
            attrs: {
              readonly: !_vm.editMode,
              mode: _vm.mode,
              tb: _vm.tb,
              CertificatServer: _vm.CertificatServer,
              CAServer: _vm.CAServer,
            },
            model: {
              value: _vm.config,
              callback: function ($$v) {
                _vm.config = $$v
              },
              expression: "config",
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "b-row",
        { staticClass: "justify-content-end" },
        [
          _vm.mode === "create" && _vm.demo
            ? _c(
                "b-col",
                { attrs: { cols: "4", lg: "2", xl: "1" } },
                [
                  _vm.mode === "create"
                    ? _c(
                        "b-button",
                        {
                          attrs: { variant: "primary" },
                          on: { click: _vm.createConfig },
                        },
                        [
                          _c("i", { staticClass: "fa-light fa-save" }),
                          _vm._v(" "),
                          _c("span", [_vm._v(_vm._s(_vm.$t("common.sve")))]),
                        ]
                      )
                    : _vm._e(),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.mode === "details" &&
          _vm.editMode === false &&
          _vm.canEditConfig &&
          _vm.demo
            ? _c(
                "b-col",
                { attrs: { cols: "4", lg: "2", xl: "1" } },
                [
                  _c(
                    "b-button",
                    {
                      attrs: { variant: "primary" },
                      on: { click: _vm.editModeActivate },
                    },
                    [
                      _c("i", { staticClass: "fa-light fa-pencil" }),
                      _vm._v(" "),
                      _c("span", [
                        _vm._v(_vm._s(_vm.$t("administration.edit"))),
                      ]),
                    ]
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.mode === "details" &&
          _vm.editMode === false &&
          _vm.canDeleteConfig &&
          _vm.demo
            ? _c(
                "b-col",
                { attrs: { cols: "4", lg: "2", xl: "1" } },
                [
                  _c(
                    "b-button",
                    {
                      attrs: { variant: "primary" },
                      on: { click: _vm.deleteConfig },
                    },
                    [
                      _c("i", { staticClass: "fa-light fa-trash" }),
                      _vm._v(" "),
                      _c("span", [_vm._v(_vm._s(_vm.$t("rights.delete")))]),
                    ]
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.mode === "details" && _vm.editMode === true && _vm.demo
            ? _c(
                "b-col",
                { attrs: { cols: "4", lg: "2", xl: "1" } },
                [
                  _c(
                    "b-button",
                    {
                      attrs: { variant: "primary" },
                      on: { click: _vm.editConfig },
                    },
                    [
                      _c("i", { staticClass: "fa-light fa-save" }),
                      _vm._v(" "),
                      _c("span", [_vm._v(_vm._s(_vm.$t("common.sve")))]),
                    ]
                  ),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }